// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3297":"css/app.6990","7283":"css/admin-app.6990"}[chunkId] + ".css";
};